import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { Transactions } from './pages/Transactions';
import { Categories } from './pages/Categories';
import { Accounts } from './pages/Accounts';
import { ImportExport } from './pages/ImportExport';
import { Stats } from './pages/Stats';

export const router = createBrowserRouter([
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '/register',
        element: <Register />,
    },
    {
        path: '/',
        element: <Layout />,
        children: [
            { index: true, element: <Dashboard /> },
            { path: 'transactions', element: <Transactions /> },
            { path: 'categories', element: <Categories /> },
            { path: 'accounts', element: <Accounts /> },
            { path: 'import-export', element: <ImportExport /> },
            { path: 'stats', element: <Stats /> },
        ],
    },
]);
